class TimeoutWarningController {

    constructor(
        $scope,
        $timeout,
        $uibModal,
        CurrentUser,
        TimeoutWarningService
    ){
        'ngInject';

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.CurrentUser = CurrentUser;
        this.TimeoutWarningService = TimeoutWarningService;
    }

    $onInit() {
        this.$scope.$on('IdleStart', () => this.idleStart());

        this.$scope.$on('IdleTimeout', () => this.idleTimeout());

        this.$scope.$on('IdleEnd', () => this.idleEnd())
    }

    /***
     * Callback function for when the idle warning is first triggered.
     */
    idleStart() {
        if (this.CurrentUser.isLoggedIn()) {
            this.TimeoutWarningService.isModalOpen = true;
            this.timeoutModal = this.openTimeoutModal();
            this.CurrentUser.logoutIdleCallback();
        }
    }

    /***
     * Callback function that is called when the timeout period has been exhausted.
     */
    idleTimeout() {
        if (this.CurrentUser.isLoggedIn()) {
            this.CurrentUser.autoLogout();
        }
    }

    /***
     * Callback function that is called when a user disrupts the warning period with new activity.
     */
    idleEnd() {
        this.TimeoutWarningService.isModalOpen = false;
        this.timeoutModal.close();
    }

    /***
     * Open the Survey Settings modal.
     */
    openTimeoutModal() {
        return this.$uibModal.open({
            component: 'TimeoutWarningModal',
            size: 'md',
            windowClass: 'custom-modal timeout-warning-modal',
            resolve: {
                maxCountdown: this.TimeoutWarningService.autoLogoutTimeoutTime
            }
        });
    }

}

export default TimeoutWarningController;


// WEBPACK FOOTER //
// ./app/common/timeout-warning/timeout-warning-controller.js